module.exports = __webpack_public_path__ + "media/packs/images/flags/HK-e537d5b8491a8680fa62283f822e17b8.svg";